import React, { useEffect, useState } from 'react';
import { useParams } from "react-router";
import { BASE_API } from '../../../api/Globals';
import { helpHttp } from '../../../helpers/helpHttp';
import { Button } from 'primereact/button';
import jsPDF from 'jspdf';

const SolicitudCedula = () => {
    const [db, setDb] = useState(null); 
    const [error, setError] = useState(null);

    let {q} = useParams();

    let url = `${BASE_API}demand/print/${q}`;

    useEffect(() => {

        helpHttp().get(url, {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Access-Control-Allow-Origin': '*'
            }
        }).then(res => { 
            if(res.response == 'on') {
                let demand = res.demand;
                setDb(demand);
                setError(false); 

                console.log("IMPRIMIR");
                jsPdfGenerator();
            } else if(res.response == 'off') {
                setError(true);
            }
        });
    }, [q]);
    
    const jsPdfGenerator = () => { 
        let doc = new jsPDF('p', 'pt', 'letter');

        doc.setProperties({title:'Solicitud'});

        let img = new Image();
        img.src='assets/layout/images/LOGOTIPO_NUEVO_SEC_PNG.png';
        doc.addImage(img,'png',120,15,177,44);
        
        const xcenter = doc.internal.pageSize.width/2;
        let x = 38;
        let y = 67;
        
        doc.setFontSize(9);

        //#region *Datos Generales
        doc.setFont('helvetica','bold');
        doc.text('Coordinación General de Registro, Certificación y Servicios a Profesionistas', x, y+8);
        doc.text('Dirección de Registro y Servicios a Profesionistas', x+55, y+19);
        doc.setFont('helvetica','normal');

        let wrect = 536;

        doc.setFillColor(217, 217, 217);
        doc.rect(x+360, 35, 176, 15, 'DF');
        doc.rect(x+360, 50, 176, 15, 'S');
        doc.rect(x+360, 65, 176, 15, 'DF');
        doc.rect(x+360, 80, 176, 15, 'S');

        doc.text('Cédula Número', x+415, 46);
        doc.text('Fecha de Solicitud', x+408, 76);

        doc.text(`c-${db.solicitudid}a`, wrect-50, 61,{align:'center',maxWidth:195});
        doc.text(db.fecha_registro, wrect-50, 91,{align:'center',maxWidth:195});

        x = 38;
        y = 100;

        //#region *Datos personales
        doc.setFont('helvetica','bold');
        doc.setFillColor(217, 217, 217);
        doc.rect(x, y+3, wrect, 20, 'FD');
        doc.text('SOLICITUD PARA REGISTRO DE TÍTULO Y EXPEDICIÓN DE CÉDULA PROFESIONAL ESTATAL', xcenter, y+16,{align:'center'});
        
        doc.setFont('helvetica','normal');
        doc.setFillColor(217, 217, 217);
        doc.rect(x, y+30, wrect, 15, 'FD');
        doc.text('DATOS PERSONALES', xcenter, y+40,{align:'center'});

        doc.setFillColor(217, 217, 217);
        doc.rect(x, y+50, 118, 60, 'DF');
        doc.line(x,y+65,x+345,y+65);  
        doc.line(x,y+80,x+345,y+80);
        doc.line(x,y+95,x+345,y+95);    
        doc.rect(x, y+50, 345, 60, 'S');

        doc.text('Apellido Paterno', x+5, y+62);
        doc.text('Apellido Materno', x+5, y+77);
        doc.text('Nombre', x+5, y+92);
        doc.text('CURP', x+5, y+107);

        doc.text(db.apellido1, x+123, y+62);             //Apellido Paterno
        doc.text(db.apellido2, x+123, y+77);              //Apellido Materno
        doc.text(db.nombre, x+123, y+92);        //Nombre
        doc.text(db.curp, x+123, y+107);            //CURP

        doc.setFillColor(217, 217, 217);
        doc.rect(x+360, y+50, 176, 15, 'DF');
        doc.rect(x+360, y+95, 58, 15, 'DF');
        doc.line(x+360,y+95,x+536,y+95);
        doc.rect(x+360, y+50, 176, 60, 'S');

        doc.text('Fecha de Nacimiento', x+405, y+62);
        doc.text('Sexo', x+378, y+107);

        doc.text(db.fechanacimiento, x+425, y+85);          //Fecha de Nacimiento
        doc.text(db.genero, x+425, y+107);           //Sexo

        doc.text('Domicilio Particular:', x+5, y+130);
        //doc.text('Núm. Ext.',x+360, y+130);
        //doc.text('Núm. Int.',x+450, y+130);
        doc.text('Colonia:', x+5, y+145);
        doc.text('Delegación o Municipio:', x+255, y+145);
        doc.text('C.P.', x+5, y+160);
        doc.text('Entidad Federativa:', x+172, y+160);
        doc.text('Teléfono(s):', x+5, y+175);
        doc.text('Correo Electrónico:', x+255, y+175);

        doc.text(db.domicilio, x+215, y+130,{align:'center',maxWidth:266}); //domicilio
        //doc.text('', x+425, y+130,{align:'center',maxWidth:40}); //numero exterior
        //doc.text('', x+510, y+130,{align:'center',maxWidth:40}); //numero interior
        doc.text(db.colonia, x+145, y+145,{align:'center',maxWidth:229}); //colonia
        doc.text(`${db.municipioid}`, x+445, y+145,{align:'center',maxWidth:180}); //municipio
        doc.text(db.codigo_postal, x+100, y+160,{align:'center',maxWidth:180}); //cp
        doc.text('Sonora', x+390, y+160,{align:'center',maxWidth:266}); //entidad
        doc.text(db.telefono, x+140, y+175,{align:'center',maxWidth:180}); //telefono
        doc.text(db.correo_electronico, x+430, y+175,{align:'center',maxWidth:190}); //telefono

        doc.line(x+88, y+131, x+354, y+131);  //linea domicilio
        doc.line(x+405, y+131, x+445, y+131); //linea num ext
        doc.line(x+490, y+131, x+530, y+131); //linea num int
        doc.line(x+40, y+146, x+250, y+146);  //linea colonia
        doc.line(x+353, y+146, x+530, y+146); //linea municipio
        doc.line(x+25, y+161, x+168, y+161);  //linea cp
        doc.line(x+255, y+161, x+530, y+161); //linea entidad
        doc.line(x+55, y+176, x+250, y+176);  //linea telefono
        doc.line(x+335, y+176, x+530, y+176);  //linea correo
        doc.rect(x, y+118, wrect, 65, 'S');
        //#endregion Datos personales

        //#region *Datos Direccion de registro y servicios
        y=290;
        doc.setFont('helvetica','normal');
        doc.setFillColor(217, 217, 217);
        doc.rect(x, y, wrect, 15, 'FD');
        doc.text('PARA USO EXCLUSIVO DE LA DIRECCIÓN DE REGISTRO Y SERVICIOS A PROFESIONISTAS', xcenter, y+11,{align:'center'});

        doc.setFillColor(217, 217, 217);
        doc.rect(x, y+20, wrect, 20, 'F');
        doc.rect(x, y+40, wrect, 20, 'S');
        doc.line(x+73,y+20,x+73,y+60);
        doc.line(x+345,y+20,x+345,y+60);
        doc.rect(x, y+20, wrect, 80, 'S');

        doc.text('APROBADO', x+12, y+33);
        doc.text('DICTAMINADOR(A)', x+165, y+30);
        doc.setFontSize(8);
        doc.text('*Sujeto a validación de autenticación', x+138, y+38);
        doc.setFontSize(9);
        doc.text('FIRMA DEL(LA) DICTAMINADOR(A)', x+365, y+33);

        const prueba='';

        doc.text('SI', x+31, y+53); //Aprobacion
        doc.text(db.validador, x+209,y+53,{align:'center'}); //Nombre Dictaminador
        doc.text(`OBSERVACIONES: ${prueba}`,x+5,y+73,{align:'justify',maxWidth:wrect-10}) //Observaciones

        doc.setFont('helvetica','bold');
        doc.text('FOTO', x+53,y+120);
        doc.text('FIRMA', x+250,y+120);
        doc.text('HUELLA', x+458,y+120);

        doc.rect(x+30, y+125, 72, 92, 'S');
        doc.rect(x+145, y+125, 252, 92, 'S');
        doc.rect(x+440, y+125, 72, 92, 'S');

        doc.setFont('helvetica','normal');
        doc.setFontSize(7);
        doc.text('Fotografía reciente tamaño infantil a color, fondo blanco y papel mate.',x+65,y+227,{align:'center', maxWidth:110});
        doc.text('Firma en tinta negra, punto mediano y sin salirse del recuadro',x+168,y+227);
        doc.text('Pulgar derecho',x+452,y+227);
        //#endregion Datos Direccion de registro y servicios

        //#region *Estudios Profesionales
        y=540;
        doc.setFontSize(9);
        doc.setFillColor(217, 217, 217);
        doc.rect(x, y, wrect, 15, 'FD');
        doc.text('ESTUDIOS PROFESIONALES', xcenter, y+11,{align:'center'});

        doc.setFillColor(217, 217, 217);
        doc.rect(x, y+20, 155, 45, 'DF');
        doc.line(x,y+35,x+wrect,y+35);  
        doc.line(x,y+50,x+wrect,y+50);
        doc.line(x,y+65,x+wrect,y+65);    
        doc.rect(x, y+20, wrect, 45, 'S');

        doc.text('Nombre de la Institución Educativa', x+5, y+32);
        doc.text('Título', x+5, y+47);
        doc.text('Entidad o País', x+5, y+62);

        doc.text(db.institucion_educativa, x+160, y+32);       //Institucion
        doc.text(db.titulo, x+160, y+47);              //Titulo
        doc.text(db.pais, x+160, y+62);                                   //Pais

        doc.setFontSize(9);
        const text=`BAJO PROTESTA DE DECIR VERDAD MANIFIESTO QUE LA INFORMACIÓN PROPORCIONADA ES VERÍDICA Y QUE LOS DOCUMENTOS QUE ACOMPAÑO SON AUTÉNTICOS. ASIMISMO, ME DOY POR ENTERADO(A) Y MANIFIESTO HABER LEÍDO LA PRESENTE SOLICITUD. DE IGUAL FORMA, MIENTRAS NO INFORME MI CAMBIO DE DOMICILIO, TELÉFONO Y CORREO ELECTRÓNICO, ESTOY DE ACUERDO EN QUE TODAS LAS NOTIFICACIONES SE ME REALICEN EN LOS DATOS SEÑALADOS EN ESTA SOLICITUD.`;

        doc.text(text, x+5, y+85,{align:'justify',maxWidth:wrect-15});
        doc.rect(x, y+75, wrect, 130, 'S');

        doc.setFont('helvetica','bold');
        doc.text('FIRMA',x+250,y+160);
        doc.line(x+145,y+190,x+400,y+190);
        //#endregion Estudios Profesionales

        doc.setFont('helvetica','normal');
        doc.text('08-CGC-P10-F01/REV.03',wrect-65,y+230);
    
        window.open(doc.output('bloburi'));     //Visualizar
    }

    /*return (
        <>
            {!error && <Button className="p-button-rounded p-button-warning p-button-outlined" icon="pi pi-print" onClick={jsPdfGenerator}></Button>}
        </>
    );*/
}

export default SolicitudCedula;